/* tslint:disable */
/* eslint-disable */
/**
 * Backoffice Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateIamRoleRequest
 */
export interface CreateIamRoleRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateIamRoleRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateIamRoleRequest
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateIamRoleRequest
     */
    accessChannelId: string;
}

export function CreateIamRoleRequestFromJSON(json: any): CreateIamRoleRequest {
    return CreateIamRoleRequestFromJSONTyped(json, false);
}

export function CreateIamRoleRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateIamRoleRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'accessChannelId': json['access_channel_id'],
    };
}

export function CreateIamRoleRequestToJSON(value?: CreateIamRoleRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'description': value.description,
        'access_channel_id': value.accessChannelId,
    };
}


